import getOperatorCustomRoutes from '@om-fe/ndw-core/src/routes/routes';


export default getOperatorCustomRoutes;
